<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div v-if="open" class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">{{ modal_title }}</h3>
        </div>
        <div class="modal-body">
          <form class="form">
            <table class="table table-basic mt-4 mb-4">
              <thead>
                <tr>
                  <th width="300">發佈單位</th>
                  <td>{{condition_data.cedvnm}}</td>
                </tr>
                <tr>
                  <th width="300">申請者</th>
                  <td>{{condition_data.last_editor}} {{condition_data.dev_nm}}</td>
                </tr>
                <tr>
                  <th width="300">申請日期</th>
                  <td>{{condition_data.apply_date | dateFormat}}</td>
                </tr>
              </thead>
            </table>

            <table class="table table-basic mt-4 mb-4">
              <thead>
                <tr>
                  <th width="300">條件名稱<br /><small>(最多二十字)</small></th>
                  <td>{{condition_data.title}}</td>
                </tr>
                <tr>
                  <th width="300">條件組合</th>
                  <td><div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3; word-break: break-all;" 
                      v-for="(value,key) in condition_data.option_ch" :key="`selectedAttaContract2-${key}`">{{ value }}</div></td>
                </tr>
                <tr>
                  <th width="300">發佈對象</th>
                  <td>{{condition_data.target}}</td>
                </tr>
                <tr>
                  <th width="300">發佈日期</th>
                  <td class="d-flex" v-if="isEdit">
                    <date-picker
                      v-model="condition_data.release_date"
                      :format="dateFormatter"
                      :language="dateLang"
                      :first-day-of-week="1" />
                      <div class="d-flex align-items-center" style="margin-left: 12px;font-size: 22px;color:#F58818">
                        <i class="icon-calendar"  />
                      </div>
                  </td>
                  <td class="d-flex" v-else>
                      {{ condition_data.release_date | dateFormat }}
                  </td>
                </tr>
                <tr>
                  <th width="300">下架日期</th>
                  <td class="d-flex"  v-if="isEdit">
                    <date-picker
                      v-model="condition_data.takeoff_date"
                      :format="dateFormatter"
                      :language="dateLang"
                      :first-day-of-week="1" />
                      <div class="d-flex align-items-center" style="margin-left: 12px;font-size: 22px;color:#F58818">
                        <i class="icon-calendar"  /> <span style="font-size:16px">（上架期間不得超過三個月）</span>
                      </div>
                  </td>
                  <td class="d-flex" v-else>
                      {{ condition_data.takeoff_date | dateFormat }}
                  </td>
                </tr>
              </thead>
            </table>


            <div class="action text-right" v-if="isEdit">
              <a @click="takeoffCondition(condition_data.id)" class="btn btn-default">
                直接下架
              </a>
              <a @click.stop.prevent="changeCondition(condition_data.id, condition_data.release_date, condition_data.takeoff_date)" class="btn btn-primary">
                修改完成
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker/components/Datepicker'
import {en, zh} from '@/components/DatePicker/locale'

export default {
  name: 'ConditionalCombinationModal',
  components: {DatePicker},
  props: {
    isEdit: {
      type: Boolean
    },
    open: {
      type: Boolean,
      default: false
    },
    condition_data: {
      type: Object,
      default: null
    },
    modal_title: {
      type: String,
      default: ''
    },
  },
  watch: {
    open (val) {
      if (val) {
        this.registerHanlink() // for 難字
      }
    },
  },
  data () {
    return {
      //Datepicker
      dateLang: zh,
      dateFormatter: (date) => {
        const m = date.getMonth() + 1
        const d = date.getDate()
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
    }
  },
  methods: {
    dateFormat: (date) => {
      date = new Date(date)
      const m = date.getMonth() + 1
      const d = date.getDate()
      return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
    },
    takeoffCondition(id) {
      this.$emit('close');
      this.$emit('takeoff-condition',id);
      this.$toast.info({title:"已下架一則條件設定"});
    },
    changeCondition(id, release_date, takeoff_date) {
      if(!/^\d{3}\/\d{2}\/\d{2}$/.test(release_date)) {
        release_date = this.dateFormat(release_date);
      }
      if(!/^\d{3}\/\d{2}\/\d{2}$/.test(takeoff_date)) {
        release_date = this.dateFormat(takeoff_date);
      }
      this.$emit('close');
      this.$emit('change-condition',id, release_date, takeoff_date);
      this.$toast.info({title:"已更新一則條件設定"});
    },
  },
  mounted () {
  }
}
</script>
